import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  strapiCreateQuotationLogForQuotation,
  strapiDeleteQuotationLog,
  strapiListQuotationLogsForQuotation,
  strapiUpdateQuotationLog,
} from '../../api/strapiQuotationLogs';
import { queryKeys } from '../queryKeys';

export function useQuotationLogsQuery(jwt: string | null, quotationDocumentId: string | null) {
  return useQuery({
    queryKey: queryKeys.quotationLogs(jwt, quotationDocumentId),
    queryFn: () => strapiListQuotationLogsForQuotation(jwt!, quotationDocumentId!),
    enabled: Boolean(jwt && quotationDocumentId),
  });
}

export function useCreateQuotationLogMutation(jwt: string | null, quotationDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (change_logs: unknown) =>
      strapiCreateQuotationLogForQuotation(jwt!, quotationDocumentId!, change_logs),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.quotationLogs(jwt, quotationDocumentId) });
    },
  });
}

export function useUpdateQuotationLogMutation(jwt: string | null, quotationDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: { documentId: string; change_logs: unknown }) =>
      strapiUpdateQuotationLog(jwt!, args.documentId, args.change_logs),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.quotationLogs(jwt, quotationDocumentId) });
    },
  });
}

export function useDeleteQuotationLogMutation(jwt: string | null, quotationDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (documentId: string) => strapiDeleteQuotationLog(jwt!, documentId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.quotationLogs(jwt, quotationDocumentId) });
    },
  });
}
